import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChange, SimpleChanges } from '@angular/core';
import { ImagePlaceholderDirective, isNullOrUndefined, SafeUrlPipe } from '@uzurv/core';
import { VehicleService } from '../../services';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'img[dotsVehicleIdentifier]',
    host: {
        '(error)': 'onError()',
        '(load)': 'onLoad()',
        '[src]': 'src'
    },
    standalone: true
})
export class VehicleImageDirective extends ImagePlaceholderDirective implements OnInit, OnChanges {

  @Input()
  dotsVehicleIdentifier: number;

  constructor(
    protected renderer: Renderer2,
    protected hostElement: ElementRef,
    protected vehicleService: VehicleService,
    protected safeUrlPipe: SafeUrlPipe
  ) {
    super(renderer, hostElement);
  }

  ngOnInit() {
    this.src = this.placeholder;
    this.fetchVehicleImage();
  }

  ngOnChanges( changes: SimpleChanges ) {
    const dotsVehicleChange: SimpleChange = changes.dotsVehicle;
    if (dotsVehicleChange) {
      if (isNullOrUndefined(dotsVehicleChange.currentValue)) {
        this.src = this.placeholder;
        return;
      }

      if (!dotsVehicleChange.currentValue.equals(dotsVehicleChange.previousValue)) {
        this.fetchVehicleImage();
      }
    } else {
      this.src = this.placeholder;
    }
  }

  refresh() {
    this.fetchVehicleImage();
  }

  onError() {
    super.onError();
  }

  onLoad() {
    super.onLoad();
  }

  private fetchVehicleImage() {

    if (isNullOrUndefined(this.dotsVehicleIdentifier)) {
      return;
    }

    this.vehicleService.getVehicleImageForVehicle(this.dotsVehicleIdentifier)
      .subscribe(fileData => {
        if (!isNullOrUndefined(fileData)) {
          this.src = this.safeUrlPipe.transform(fileData.getDataURLString());
        }
      }, err => {
        this.src = this.placeholder;
      });
  }
}
